import { MDSActionMenuWithContent } from "@/mds/components/menu/action-menu/action-menu-with-content";
import {
  MDSMenuDropdownPopover,
  MDSMenuDropdownProps,
  MDSMenuDropdownSlotName,
} from "@/mds/components/menu/menu-dropdown";
import { MDSMenuContentList } from "@/mds/components/menu/menu.types";
import { DialogTrigger } from "react-aria-components";

interface MDSActionMenuDropdownProps extends MDSMenuDropdownProps {
  contentList: MDSMenuContentList;
}

export const MDSActionMenuDropdown = ({
  contentList,
  children,
  popoverProps,
  ...props
}: MDSActionMenuDropdownProps) => {
  if (contentList.length === 0) return children;
  return (
    <DialogTrigger isOpen={props.isOpen} onOpenChange={props.onOpenChange}>
      {children}
      <MDSMenuDropdownPopover {...popoverProps} placement={props.placement}>
        <MDSActionMenuWithContent contentList={contentList} slot={MDSMenuDropdownSlotName.Menu} />
      </MDSMenuDropdownPopover>
    </DialogTrigger>
  );
};
